import { render, staticRenderFns } from "./removeStopSellingList.vue?vue&type=template&id=bbfaad78&scoped=true"
import script from "./removeStopSellingList.vue?vue&type=script&lang=js"
export * from "./removeStopSellingList.vue?vue&type=script&lang=js"
import style0 from "./removeStopSellingList.vue?vue&type=style&index=0&id=bbfaad78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfaad78",
  null
  
)

export default component.exports